<!-- <template>
	<div class="module_container full" style="position: relative;" v-loading="loading">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:ref="moduleName+'_list'">

		</vxe-grid>
			<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />

		<vxe-table :data="exportData" style="display: none;" ref="exportTable">
			<vxe-column field="goods_code" title="商品编码" cell-type="string"></vxe-column>
			<vxe-column field="goods_name" title="商品名称" cell-type="string"></vxe-column>
			<vxe-column field="goods_model" title="商品规格" cell-type="string"></vxe-column>
			<vxe-column field="supplier_code" title="供应商编码" cell-type="string"></vxe-column>
			<vxe-column field="warehouse_code" title="仓库编码" cell-type="string"></vxe-column>
			<vxe-column field="type" title="策略类型" cell-type="string"></vxe-column>
			<vxe-column field="suggestnum" title="建议采购数量" cell-type="string"></vxe-column>
			<vxe-column field="gettime" title="预计到仓时间" cell-type="string"></vxe-column>
			<vxe-column field="mark" title="备注" cell-type="string"></vxe-column>
		</vxe-table>

	</div>
</template>
<style>

</style>
<style scoped>

</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'

	export default {
		extends: listBase,
		name: 'policyIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-tag type="danger" size="mini">综合价格 = 含税价 + (商品重量*运费) + (含税价*额外费用)</el-tag>,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'policy',
				windowName: '采购策略',
				loading: false,
				exportData: []
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			
			// add() {
			// 	import('@/components/forms/policy/form.vue').then((res) => {
			// 		this.formModule = {
			// 			component: res.default,
			// 			name: 'policy',
			// 			id: 0,
			// 			controlltype: 1,
			// 			show: true,
			// 		}
			// 	})
			// },
			// edit(row) {
			// 	import('@/components/forms/policy/form.vue').then((res) => {
			// 		this.formModule = {
			// 			component: res.default,
			// 			name: 'policy',
			// 			id: row.id,
			// 			controlltype: 2,
			// 			show: true,
			// 		}
			// 	})
			// },
			// importMethod(e) {
			// 	let file = e.file
			// 	let formData = new FormData()
			// 	formData.append('excle', file)
			// 	return new Promise((resolve) => {
			// 		this.$api[this.moduleName].import(formData).then((res) => {
			// 			if (res.errorData.length != 0) {
			// 				let message = ''
			// 				res.errorData.forEach((item) => {
			// 					message = message + item.goodscode + '：' + item.erro + '</br>'
			// 				})

			// 				this.$alert(message + '系统已忽略', res.errorData.length + '条数据错误', {
			// 					dangerouslyUseHTMLString: true
			// 				})
			// 			} else {
			// 				this.$message.success('操作成功')
			// 			}
			// 			this.customreload()
			// 			resolve()
			// 		}, (e) => {
			// 			this.$message.error(e);
			// 			resolve()
			// 		})
			// 	})

			// },
			// exportMethod() {
			// 	this.$VXETable.modal.confirm('您确定要全部数据吗？').then((type) => {
			// 		if (type == 'confirm') {
			// 			this.loading = true
			// 			this.$api[this.moduleName].export().then((res) => {
			// 				this.exportData = res
			// 				for (let i = 0; i < res.length; i++) {
			// 					res[i]['type'] = res[i]['type'] == 311 ? '备货采购' : '紧急采购'
			// 				}

			// 				this.$refs.exportTable.exportData({
			// 					filename: 'policy_export',
			// 					type: 'xlsx',
			// 					data: res,
			// 				})
			// 				this.loading = false
			// 			})
			// 		}
			// 	})
			// },
			// importtemplate() {
			// 	this.$store.commit('getTemplate', 'policy')
			// }
		},
		components: {

		}
	}
</script>
